import React from 'react';
import { Select } from '@v2/components';
import { PluginFiltersProps } from './types';
import { styles } from './styles';

const PluginFilters: React.FC<PluginFiltersProps> = ({
  supportedPimsOptions,
  supportedPimsId,
  onSupportedPimsChange,
  includeInactive,
  onIncludeInactiveChange,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.supportedPimsSelect}>
        <Select
          id="supported-pims"
          options={supportedPimsOptions}
          value={supportedPimsId}
          onChange={e => onSupportedPimsChange(e.target.value)}
          aria-label="Supported PIMS"
          className={styles.selectElement}
        />
      </div>
      <label className={styles.checkboxLabel}>
        <input
          type="checkbox"
          checked={includeInactive}
          onChange={e => onIncludeInactiveChange(e.target.checked)}
          className={styles.checkbox}
        />
        Include Inactive Plugins
      </label>
    </div>
  );
};

export default PluginFilters;
export type { PluginFiltersProps } from './types';
